import React from "react";
import PropTypes from 'prop-types';

import Panel from "shared/react_components/Panel";
import DateFormatter from "shared/formatters/dates";

import IntegrationStatus from "./IntegrationStatus";

export default class Overview extends React.Component {
  static propTypes = {
    integratedBy: PropTypes.string,
    integratedOn: PropTypes.string,
    children: PropTypes.object,
    status: IntegrationStatus.propTypes.status,
    integrationName: IntegrationStatus.propTypes.integrationName
  };

  // This is defaulting itself rather than using defaultProps because there
  // is additional formatting and would rather pass null/undefined to branch
  // out of formatting the timestamp.
  integratedOn() {
    const { integratedOn } = this.props;

    if (integratedOn) {
      return DateFormatter.fromDB(integratedOn);
    } else {
      return "-";
    }
  }

  // This is defaulting manually to allow explicit passing of null or undefined while
  // still appropriately defaulting the value for integratedBy
  integratedBy() {
    return this.props.integratedBy || "-";
  }

  renderIntegrationStatus() {
    const { status, integrationName, integratedOn } = this.props;

    if (integratedOn) {
      return <IntegrationStatus status={status} integrationName={integrationName} />;
    } else {
      return <IntegrationStatus status="NoAccounts" integrationName={integrationName} />;
    }
  }

  render() {
    return (
      <Panel title="Overview">
        <div className="d-flex">
          <div className="mr-large">
            <label className="control-label emphasis">Status</label>
            {this.renderIntegrationStatus()}
          </div>
          <div className="mr-large">
            <label className="control-label emphasis">Integrated By</label>
            <div data-attr="integrated-by">{this.integratedBy()}</div>
          </div>
          <div className="mr-large">
            <label className="control-label emphasis">Integrated On</label>
            <div data-attr='integrated-on'>{this.integratedOn()}</div>
          </div>
          {this.props.children}
        </div>
      </Panel>
    );
  }
}
